import React from "react";

const Header = (props) => {
    return (
        <div>
            <header className="main-header stricky-fixed">
                {/*Start header top*/}
                <div className="header-top">
                    <div className="container">
                        <div className="header-top-content">
                            <div className="row">
                                <div className="col-lg-8 col-md-7 col-sm-12 col-xs-12">
                                    <div className="header-contact-info">
                                        <ul>
                                            <li><i className="flaticon-telephone" />(318) 377-1776</li>
                                            <li><i className="flaticon-interface-1" />daniel@altcollision.com</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*End header top*/}
                <nav className="header-lower navbar navbar-default">
                    <div className="container">
                        {/* Brand and toggle get grouped for better mobile display */}
                        <div className="navbar-header">
                            {/* <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
                                <span className="sr-only">Toggle navigation</span>
                                <span className="icon-bar" />
                                <span className="icon-bar" />
                                <span className="icon-bar" />
                            </button> */}
                            <a className="navbar-brand"><img src="img/resources/alt_logo_300.png" alt="ArkLaTex Logo" style={{ width: "200px" }} /></a>
                        </div>
                        {/* Collect the nav links, forms, and other content for toggling */}
                        <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
                            <ul className="nav navbar-nav navbar-right">
                                {/* <li><a href="#">Home</a></li>
                                <li><a href="#">Status</a></li> */}
                            </ul>
                        </div>{/* /.navbar-collapse */}
                    </div>{/* /.container-fluid */}
                </nav>
            </header>
            {/*End header area*/}
            {/*Start breadcrumb area*/}
            <section className="breadcrumb-area">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="breadcrumbs text-center">
                                <h1>Check Repair Status</h1>
                                <h4>Use the form below for live updates</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/*End breadcrumb area*/}
            {/*Start breadcrumb bottom area*/}
            <section className="breadcrumb-bottom-area">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 col-md-5 col-sm-5">
                            <ul>
                                <li><a href="#">Home</a></li>
                                <li><i className="fa fa-angle-right" /></li>
                                <li>Status</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
            {/*End breadcrumb bottom area*/}
        </div>

    )
}

export default Header